<template>
	<div class="order">
		<ul class="uk-grid-match uk-grid-small" uk-grid>
			<li class="uk-width-2-5@s">
				<div class="order__block order__block--first">
					<div class="order__title">Варианты оплаты</div>
					<div class="order__spis">
						<label>
							<input class="uk-radio" type="radio" value="1" v-model="prepay" name="prepay" checked>
							<span>Предоплата</span>
						</label>

						<label>
							<input class="uk-radio" :disabled="$parent.user.has_orders == 0" type="radio" value="0" v-model="prepay" name="prepay">
							<span>Отсрочка платежа</span>
						</label>
					</div>

					<hr>
					<div class="curators" v-if="$parent.user.my_curator.length > 0">
						<div class="order__subtitle">Ваш куратор</div>
						<div class="order__spis">
							<label v-for="curator, i in $parent.user.my_curator">
								<input class="uk-radio" type="radio" :value="curator.id" v-model="current_curator">
								<span>{{ curator.name }}</span>
							</label>
						</div>
					</div>

					<div class="order__button">
						<button class="uk-button uk-button-primary" @click="checkBeforeSend">
							<img :src="$parent.url + '/themes/oprava/assets/img/ico-button-cart.svg'" alt="">
							<span>ОФОРМИТЬ ЗАКАЗ</span>
						</button>
					</div>
				</div>
			</li>
			<li class="uk-width-3-5@s uk-flex-first uk-flex-last@s">
				<div class="order__block">
					<div class="order__title">Детали заказа</div>
					<div class="order__total">
						<div class="order__subtitle">Сумма:</div>
						<strong>{{ totals | cifer }} ₽</strong>
					</div>
					<div class="order__total">
						<div class="order__subtitle">Оплата бонусами:</div>
						<strong>{{ bonus | cifer }} ₽</strong>
					</div>
					<div class="order__total" v-if="glob_accia">
						<div class="order__subtitle">{{ glob_accia.title }}</div>
						<strong>{{ getGlobalAccia }} ₽</strong>
					</div>
					<hr>
					<div class="order__total">
						<div class="order__subtitle">Сумма к оплате:</div>
						<strong>{{ totalAfterDiscounts | cifer }} ₽</strong>
					</div>
					<hr>
					<div class="order__bonus" v-if="bonusCash > 0">
						<div class="order__subtitle">Скидки к заказу</div>
						<div class="order__podp">На вашем бонусном счету
							<strong>{{ bonusCash }} рублей</strong>. Вы можете использовать их при заказе при условии, что общая сумма бонусов не будет превышать 10% от суммы заказа.
						</div>
						<input type="text" class="js-bonus" name="bonus" value="" />
					</div>
				</div>
			</li>
		</ul>
		<wait></wait>
	</div>
</template>

<script>
  import { bus } from './bus.js'
  import { finance } from "../mixins/finance"
  import ionRangeSlider from 'ion-rangeslider'
  import wait from './wait'

  export default {
    name: "order",
    mixins: [finance],
	  components: { wait },
    data() {
      return {
        pay: 'Предоплата',
        bonusCash: this.$parent.user.inner_coin.cash_back,
        bonus: 0,
        prepay: 1,
	      glob_accia: {
          title: 'Акция открытие',
		      discount: 10,
		      to: new Date(2019, 9, 1)
	      },
        current_curator: '',
        rangeSlider: '',
        total: {
          cart: ''
        },
        order: {},
      }
    },
    props: {
      cart: {}
    },
    watch: {
      cart: {
        handler(newVal, oldVal) {
          this.updateSlider();
        },
        deep: true,
      },
      prepay: function () {
        bus.$emit('change-prepay', this.prepay);
        this.updateSlider();
      }
    },
    computed: {
      totals() {
        let items = this.cart;
        let sum = 0;
        for (let key in items) {
          let price = items[key].seria.price * 1;
          sum = sum + (this.returnPrice(price) * items[key].count);
        }
        return sum;
      },
      getProcent() {
        let procVal = 10;
        let bonusCash = this.bonusCash;
        let total = this.totals;
        let procent = Math.round((total / 100) * procVal);
        if (procent > bonusCash) procent = bonusCash;
        return procent;
      },
      getInnerCoin() {
        return this.$parent.user.inner_coin.cash_back;
      },
      getCurrentOrder() {},
	    getGlobalAccia(){
        if(this.glob_accia){
          let total = this.totals;
          let discount = this.glob_accia.discount;
          let res = this.percent(total, discount);
          return Math.round(res);
        };
        return 0;
	    },
	    totalAfterDiscounts(){
        return this.totals - this.bonus - this.getGlobalAccia;
	    }
    },
    methods: {
      checkCurators(){
        let curators = this.$parent.user.my_curator;
        if(curators.length == 1){
          this.current_curator = curators[0].id;
        }
      },
      updateSlider() {
        let app = this;
        if(this.rangeSlider){
          this.rangeSlider.update({
            max: app.getProcent
          });
        }

      },
      slider() {
        let maxCount = this.getProcent;
        let app = this;
        this.rangeSlider = $(".js-bonus").ionRangeSlider({
          skin: "round",
          min: 0,
          max: maxCount,
          //hide_from_to: true,
          grid: false,
          onChange() {
            /*if(oc.options.hide_from_to){
              oc.update({
                hide_from_to: false
              });
            }*/
          },
          onFinish(d) {
            app.bonus = d.from;
          }
        }).data("ionRangeSlider");
      },

	    checkBeforeSend(){
        if(this.$parent.user.my_curator.length > 0 && this.current_curator){
          this.sendOrder();
        } else {
          alert('Выберите куратора');
        }
	    },

      sendOrder() {
        bus.$emit('wait', true);
        let fd = {
          'user_id': this.$parent.user.id,
          'curator_id': this.current_curator,
          'pay_type': this.prepay == 1 ? 'Предоплата' : 'Отсрочка платежа',
          'bonus_used': this.bonus,
          'items': this.cart,
          'accia': this.getGlobalAccia(),
          'total': this.totalAfterDiscounts
        };
        console.log(fd);
        $.request('onSendOrder', {
          data: fd,
          success: function (data) {
            //... do something ...
            bus.$emit('wait', false);
            console.log(data);
            window.location.href = "/thanks";
            //bus.$emit('newOrder', data.order);
            //bus.$emit('cart-reload', data.cart);
            //this.success(data);
          },
          error: function (err) {
            console.log(err);
          },
        })
        //console.log(this.order);
      }
    },
    mounted() {
      this.slider();
      this.checkCurators();
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// themes/oprava/src/js/components/commerce/order.vue